export enum CuroApplicationVariables {
  ApplicationDisplayId = 'application_display_id',
  BorrowerEmail = 'borrower_email',
  BorrowerPhone = 'borrower_phone',
  BorrowerFirstName = 'borrower_first_name',
  BorrowerLastName = 'borrower_last_name',
  BorrowerDateOfBirth = 'borrower_date_of_birth',
  BorrowerPersonalIdNumber = 'borrower_personal_id_number',
  BorrowerHomeAddress = 'borrower_home_address',
  BorrowerStreetAddress = 'street_name',
  BorrowerCity = 'city',
  BorrowerStateOrProvince = 'state_or_province',
  BorrowerZipOrPostalCode = 'zip_or_postal_code',
  PreliminaryCheckResult = 'preliminary_check_result',
  PreliminaryCheckCompleted = 'preliminary_check_completed',
  DocumentsRequested = 'documents_requested',
  EmailVerificationCodeSendingAttemptsCount = 'email_verification_code_sending_attempts_count',
  PhoneVerificationCodeSendingAttemptsCount = 'phone_verification_code_sending_attempts_count',
  AvailableLoanOffers = 'available_loan_offers',
  ApplicationExpirationDate = 'application_expiration_date',
  DocumentsUploaded = 'documents_uploaded',
  PlaidAuthAndIdentityIntegrationsPassed = 'plaid_auth_and_identity_integrations_passed',
  PlaidCraIntegrationsPassed = 'plaid_cra_integrations_passed',
  PlaidIdentityAccountStringData = 'plaid_identity_account_string_data',
  SelectedLoanOffer = 'selected_loan_offer',
  BankAccountData = 'bank_account_data',
  BankAccountType = 'bank_account_type',
  BankRoutingNumber = 'bank_routing_number',
  BankAccountNumber = 'bank_account_number',
  AutoPay = 'autopay',
  BankAccountNumberMasked = 'bank_account_number_masked',
  BorrowerIncomeInformation = 'borrower_income_information',
  BankAccountInformationManualEntry = 'bank_account_information_manual_entry',
  WellsFargoTransactionStatusDateAndTime = 'wells_fargo_transaction_status_date_and_time',
  ProductType = 'product_type',
  SnowflakeBorrowerBranchAddress = 'snowflake_borrower_branch_address',
  SnowflakeBorrowerBranchPhone = 'snowflake_borrower_branch_phone',
  SnowflakeBorrowerFirstName = 'snowflake_borrower_first_name',
  SnowflakeBorrowerOfferAmount = 'snowflake_borrower_offer_amount',
  OrigGpsLoanOrAccountNumber = 'orig_gps_loan_or_account_number',
  PayoffAmount = 'payoff_amount',
  CashToCustomer = 'cash_to_customer',
  SendSummitLeadEmail = 'send_summit_lead',
  SummitEncryptedLeadId = 'summit_encrypted_lead_id',
  RefiScoreCheckResult = 'refi_score_check_result',
  BranchStreet = 'branch_street',
  BranchCityStateZip = 'branch_city_state_zip',
  BorrowerStatus = 'borrower_status',
  GpsGetLoansStrategyVersion = 'gps_get_loans_strategy_version',
  OrganicOfferPageTextOne = 'organic_offer_page_text_1',
  OrganicOfferPageTextTwo = 'organic_offer_page_text_2',
  OrganicLoanOfferViewedTechnical = 'organic_loan_offer_viewed_technical',
  MaxSecured = 'max_secured',
  SnowflakeRefiReloanExecuted = 'snowflake_refi_reloan_executed',
  OfferExpirationDate = 'offer_expiration_date',
  ReleaseVersion = 'release_version',
  SmallLoanRefiJourney = 'small_loan_refi_journey',
  GpsBankAccountVerified = 'gps_bank_account_verified',
  OrigGpsBankAccountInformation = 'orig_gps_bank_account_information',
  LoanDocsSigned = 'loan_docs_signed',
  BranchType = 'branch_type',
  AorPass = 'aor_pass',
  OfferType = 'offer_type',
  FirstPaymentDate = 'first_payment_date',
  SendNextStepsEmail = 'send_next_steps_email',
  SendOfferDetailsEmail = 'send_offer_details_email',
  ConnectBankAccountMoreInformationNeededInteractionTechnical = 'connect_bank_account_more_information_needed_interaction_technical',
  ConnectBankAccountForFundingDisplayedTechnical = 'connect_bank_account_for_funding_displayed_technical',
  ConnectBankAccountForFundingInteractionTechnical = 'connect_bank_account_for_funding_interaction_technical',
  BranchOfferDisplayedTechnical = 'branch_offer_displayed_technical',
  BranchOfferInteractionTechnical = 'branch_offer_interaction_technical',
  SecondChanceCashflowAndAutoOriginationStrategyRan = 'second_chance_cashflow_and_auto_origination_strategy_ran',
  PpcJourney = 'ppc_journey',
  PpcJourneyOfferDisplayedTechnical = 'ppc_journey_offer_displayed_technical',
}

export enum AvailableOffersTableVariables {
  ProductName = 'product_name',
  LoanAmount = 'loan_amount',
  Apr = 'apr',
  TermInMonths = 'term_in_months',
  MonthlyPayment = 'monthly_payment',
  FinanceCharge = 'finance_charge',
  TotalPayment = 'total_payment',
  LoanType = 'loan_type',
}

export enum BorrowerIncomeInformationVariables {
  PaycheckFrequency = 'pay_frequency',
  NextPayDate = 'next_pay_date',
}

export enum BankAccountDataVariables {
  AccountId = 'account_id',
  AccountMask = 'account_mask',
  AccountName = 'account_name',
  BankAccountType = 'bank_account_type',
  BankRoutingNumber = 'bank_routing_number',
  BankAccountNumber = 'bank_account_number',
  Selected = 'selected', 
  Displayed = 'displayed', 
}

export enum OrigGpsBankAccountInformationVariables {
  AccountType = 'account_type',
  BankRoutingNumber = 'bank_routing_number',
  BankAccountNumber = 'bank_account_number',
}
